"use client";

export const APP_STATE_STORAGE_KEY = "state";
export const APP_STATE_STORAGE_EVENT = "app-state-storage-change";

export function getStoredState() {
  if (typeof window === "undefined") {
    return "";
  }

  return window.localStorage.getItem(APP_STATE_STORAGE_KEY) || "";
}

export function setStoredState(value: string) {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(APP_STATE_STORAGE_KEY, value);
  window.dispatchEvent(new CustomEvent(APP_STATE_STORAGE_EVENT, { detail: value }));
}

export function clearStoredState() {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(APP_STATE_STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(APP_STATE_STORAGE_EVENT, { detail: "" }));
}
